import * as ModalFullscreen from './components/ModalFullscreen.css';
export default {
    ModalFullscreen
};
